<template>
  <div class="thanks-view view row justify-content-center align-items-center">
    <div class="col-11 col-sm-6 col-lg-5 col-xl-4 text-center">
      <h2 class="text-uppercase mb-5">{{ $t('shared_thanks.title') }}</h2>
      <p>{{ $t('shared_thanks.body') }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SharedThanks',
}
</script>
